import { StringSchema, string } from 'yup';

import { isProd } from '../../config';

const ssnRegExp = /^[0-9]{3}[-][0-9]{2}[-][0-9]{4}$/;
const ssnLast6RegExp = /^[Xx]{3}[-][0-9]{2}[-][0-9]{4}$/;
const ssnLast4RegExp = /^[Xx]{3}[-][Xx]{2}[-][0-9]{4}$/;

const issuedSsnRegExp = /^(?!000|666)[0-8]\d{2}(?!00)\d{2}(?!0000)\d{4}$/;
const itinRegExp = /^9\d{2}(?:5\d|6[0-5]|7\d|8[0-8]|9[0-2]|9[4-9])\d{4}$/;

export const isIssuableSsn = (ssn: string) => {
  const digits = ssn.replace(/\D/g, '');
  return issuedSsnRegExp.test(digits) || itinRegExp.test(digits);
};

const ssnValidation = (ssnValidationRegex: RegExp, message: string) =>
  string()
    .required(message)
    .matches(ssnValidationRegex, message)
    .test('no-repeating-digits', 'Please enter a valid SSN', (value) => {
      if (!value) return true;
      return !/(\d)\1{5,}/.test(value.replace(/\D/g, '')); // Remove non-digits and check for 6+ consecutive repeats
    });

// Experian sandbox test SSNs fail real-world rules, so only prod enforces them — same as DD 1.0.
const neverIssued = (schema: StringSchema) =>
  schema.test(
    'never-issued',
    'Please enter a valid SSN',
    (value) => !isProd || !value || isIssuableSsn(value),
  );

const enterAValue = 'Please enter a value';

export const ssnLast4Validation = ssnValidation(ssnLast4RegExp, enterAValue);
export const ssnLast6Validation = ssnValidation(ssnLast6RegExp, enterAValue);
export const ssnFullValidation = neverIssued(ssnValidation(ssnRegExp, 'Please enter a valid SSN'));
export const loanAppSsnFullValidation = string().when('must_enter_ssn', {
  is: true,
  then: ssnFullValidation,
  otherwise: string().notRequired(),
});
